// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2xQpD","empty":"ModalGraph_empty__2cHwl"};